import * as React from 'react';
import './CustomPickerSaturationPointer.scss';

export default function CustomPickerSaturationPointer() {
  return <div className={'pointer-saturation'}><div></div></div>;
}
